import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl, defineMessages } from 'react-intl';

import moment from 'moment';
import * as commonVar from 'libs/commonVar';

import { ReduxFormDatePicker, ReduxFormMaterialTextField, SendReserve } from 'components';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './StartExam.css';
const cx = classNames.bind(styles);

class StartExamWizardContentStep2 extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      formStore,
      fieldInfo,
      startDate,
      endDate,
      handleDatePickerOnChangeStart,
      handleDatePickerOnChangeEnd
    } = this.props;

    let reserveExam = '';
    let periodExam = '';

    if (formStore && formStore.values && formStore.values.examStartDate) {
      const startMoment = moment(formStore.values.examStartDate);
      if (moment() < startMoment) {
        reserveExam = defineMessages(
          formatMessage({ id: 'StartExamWizardContent_11', defaultMessage: '훈련을 예약함' })
        );
      }

      if (formStore.values.examEndDate && formStore.values.examEndDate > formStore.values.examStartDate + 86400 * 2) {
        const endMoment = moment(formStore.values.examEndDate);
        periodExam =
          defineMessages(formatMessage({ id: 'StartExamWizardContent_12', defaultMessage: '훈련 기간' })) +
          ': ' +
          moment.duration(endMoment.diff(startMoment)).humanize();
      }
    }

    return (
      <div className={cx('step2-content-area')}>
        <div className={cx('exam-name-area')}>
          <span className={cx('materialTextField-title')}>{fieldInfo.examName.label}</span>
          <ReduxFormMaterialTextField
            fullWidth
            name="examName"
            className={cx('input-area')}
            checkType={101}
            validate={['required', 'examName']}
            noerror
            error={fieldInfo.examName.error}
            autoComplete="off"
          />
        </div>
        <div className={cx('exam-period-area')}>
          <div className={cx('period-date')}>
            <div className={cx('period-start-date')}>
              <span className={cx('materialTextField-title')}>{fieldInfo.examStartDate.label}</span>
              <ReduxFormDatePicker
                defaultValue={moment()}
                helperText={reserveExam}
                helperTextClassName="start-date-detail"
                className={cx('date-input')}
                fullWidth
                name="examStartDate"
                locale={localStorage.getItem('language')}
                todayButton="Today"
                shouldCloseOnSelect //={false}
                selectsStart
                showYearDropdown
                dropdownMode="select"
                showMonthDropdown
                dateFormat={localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD'}
                startDate={startDate}
                minDate={moment()}
                maxDate={moment('2037-11-30')}
                endDate={endDate}
                onChange={handleDatePickerOnChangeStart}
                // inputLabel={fieldInfo.examStartDate.label}
                checkType={101}
                validate={['dateRequired', 'reduxFormDatePicker']}
                // noerror
                error={fieldInfo.examStartDate.error}
              />
            </div>
            <div className={cx('period-end-date')}>
              <span className={cx('materialTextField-title')}>{fieldInfo.examEndDate.label}</span>
              <ReduxFormDatePicker
                defaultValue={moment().add(1, 'd')}
                helperText={periodExam}
                helperTextClassName="end-date-detail"
                className={cx('date-input')}
                name="examEndDate"
                locale={localStorage.getItem('language')}
                // todayButton="Today"
                shouldCloseOnSelect
                selectsEnd
                showYearDropdown
                dropdownMode="select"
                showMonthDropdown
                dateFormat={localStorage.getItem('language') === 'en' ? 'MM/DD/YYYY' : 'YYYY-MM-DD'}
                startDate={moment(startDate).add(1, 'd')}
                minDate={moment(startDate).add(1, 'd')}
                maxDate={moment('2037-12-31')}
                endDate={endDate}
                onChange={handleDatePickerOnChangeEnd}
                // inputLabel={fieldInfo.examEndDate.label}
                checkType={101}
                validate={['dateRequired', 'reduxFormDatePicker']}
                // noerror
                error={fieldInfo.examEndDate.error}
              />
            </div>
          </div>
        </div>
        {/* 훈련 메일 나눔 발송 */}
        <SendReserve
          sendReserveEnable={!!formStore.values.sendReserveEnable ? formStore.values.sendReserveEnable : 0}
          examStartDate={formStore.values.examStartDate}
          examEndDate={formStore.values.examEndDate}
          sendReservePeriod={!!formStore.values.sendReservePeriod ? formStore.values.sendReservePeriod : 1}
          sendReserveHour={
            !!formStore.values.sendReserveHour
              ? [formStore.values.sendReserveHour[0], formStore.values.sendReserveHour[1]]
              : [0, 24]
          }
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  templateAttach: state.templateAttach.getIn(['data', 'success']),
  templateAttachIndex: state.templateAttach.get('listIndexByNo')
});

export default connect(mapStateToProps)(injectIntl(StartExamWizardContentStep2));



// WEBPACK FOOTER //
// ./src/script/components/exam-start/StartExamWizardContentStep2.js